import { http } from "./http.js";

export interface DashboardStats {
  orders_total: number;
  orders_24h: number;
  queued_events: number;
  dead_events: number;
  errors_24h: number;
  last_synced_at: number | null;
}

export async function getStats(): Promise<DashboardStats> {
  const res = await http.get<DashboardStats>("/dashboard/stats");
  return res.data;
}
